module.exports = __webpack_public_path__ + "static/img/20.93052753.png";